<template>
    <nav aria-label="breadcrumb">
        <ol class="breadcrumb">
            <li class="breadcrumb-item">
                <a :href=route_back>Список устройств</a>
            </li>
            <li class="breadcrumb-item active" aria-current="page">История изменения статусов</li>
        </ol>
    </nav>

    <div class="table-responsive">
        <table class="table">
            <thead>
                <tr>
                    <th v-for="elem in thead">{{ elem }}</th>
                </tr>
            </thead>
            <tbody>
                <tr v-for="row in tbody">
                    <td>{{ row.tbody.created_at }}</td>
                    <td>{{ row.tbody.title }}</td>
                    <td>{{ row.tbody.number }}</td>
                    <td>{{ row.tbody.street }}</td>
                    <td>{{ row.tbody.name }}</td>
                </tr>
            </tbody>
        </table>
    </div>
</template>

<script>
import StatusHistory from '../../../../models/StatusHistory';

export default {
    name: 'DeviceStatusHistoryComponent',
    props: {
        route_get: String,
        route_back: String,
        device_id: String
    },
    data: function () {
        return {
            history: new StatusHistory({
                route_get: this.route_get
            }),
            thead: [
                'Дата', 'Статус', '№ аптеки', 'Адрес', 'Клиент'
            ],
            tbody: [],
        };
    },
    methods: {
        loadTable: async function () {
            let response = await this.history.loadTable(this.device_id);
            this.tbody = response.tbody;
        },
    },
    mounted() {
        this.loadTable();
    }
};
</script>
